<template>
  <v-main>
    <BaseCrudTable ref="basetable"
                   :headers="headers"
                   table-name="Группы клиентов"
                   endpoint="groups"
                   label="Группы клиентов"
                   @editClicked="editClick">
      <template v-slot:editVals>
        <v-col>
          <div ref="form">
            <v-card-text>
              <v-text-field
                ref="name"
                v-model.trim="editItem.name"
                :rules="[() => !!editItem.name || 'Поле обязательно']"
                :error-messages="errorMessages"
                label="Имя"
                placeholder="Введите имя"
                required />
            </v-card-text>
            <v-card-actions>
              <v-btn text @click="close()">
                Отмена
              </v-btn>
              <v-spacer />
              <v-slide-x-reverse-transition>
                <v-tooltip
                  v-if="formHasErrors"
                  left />
              </v-slide-x-reverse-transition>
              <v-btn color="primary" text @click="submit">
                Подтвердить
              </v-btn>
            </v-card-actions>
          </div>
        </v-col>
      </template>
    </BaseCrudTable>
  </v-main>
</template>

<script>
import BaseCrudTable from '../base/BaseCrudTable'

export default {
  name: "CustomerGroupsTable",
  components: {BaseCrudTable},
  data () {
    return {
      headers: [
        {text: '', value: '', align: 'left'},
        {text: 'id', value: 'id', align: 'left', class:['d-none']},
        {text: 'Название', value: 'name', align: 'left'},
        {text: 'deleted', value: 'deleted', align: 'left', class:['d-none']},
        {text: 'Действия', value: '', align: 'center'}
      ],
      editItem: {
        name: '',
        id: ''
      },
      dialog: false,
      errorMessages: '',
      formHasErrors: false
    }
  },
  computed: {
    form () {
      return {
        name: this.editItem.name
      }
    }
  },
  methods: {
    editClick (newVal) {
      this.simpleEditClick(newVal)
    },
    submit () {
      this.formSubmit()
      this.$store.dispatch("tableData/loadCustomerGroups")

    },
    close () {
      this.$refs["basetable"].close()
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tables/CustomerGroupsTable.vue